import { render, staticRenderFns } from "./EditOrientation.vue?vue&type=template&id=1cf191e6&scoped=true"
import script from "./EditOrientation.vue?vue&type=script&lang=ts"
export * from "./EditOrientation.vue?vue&type=script&lang=ts"
import style0 from "./EditOrientation.vue?vue&type=style&index=0&id=1cf191e6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf191e6",
  null
  
)

export default component.exports